import React, { Component } from "react";
import { Link } from "react-router-dom";

// ContactDetails
import {
  address,
  telefon,
  email,
  instagramUrl,
  facebookUrl,
  tiktokUrl,
} from "../../utils/constants";

// Images
import logo2 from "../../images/logo-white.svg";
import icon1 from "../../images/icon/contact/icon1.png";
import icon2 from "../../images/icon/contact/icon2.png";
import icon3 from "../../images/icon/contact/icon3.png";

class aboutSection extends Component {
  render() {
    return (
      <>
        <footer className="footer">
          {/* Footer Info */}
          <div className="footer-info bg-primary">
            <div className="container">
              <div className="row align-items-center justify-content-center d-md-flex d-sm-block">
                <div className="col-lg-3 col-md-12 col-sm-12 mb-30 d-flex justify-content-start">
                  <div className="footer-logo">
                    <img src={logo2} alt="KBS Center Logo" />
                  </div>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12 mb-30 d-sm-flex justify-content-srart">
                  <div className="feature-container left footer-info-bx">
                    <div className="icon-md">
                      <span className="icon-cell">
                        <img src={icon3} alt="Location icon" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <Link
                        to="https://www.google.com/maps/search/?api=1&query=Filaregatan+6,+44234+Kungälv"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {address}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12 mb-30 d-sm-flex justify-content-start">
                  <div className="feature-container left footer-info-bx ">
                    <div className="icon-md">
                      <span className="icon-cell">
                        <img src={icon1} alt="Phone icon" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <p>
                        <Link href={`tel:${telefon}`}>{telefon}</Link>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12 mb-30 d-sm-flex justify-content-start">
                  <div className="feature-container left footer-info-bx ">
                    <div className="icon-md">
                      <span className="icon-cell">
                        <img src={icon2} alt="Email icon" />
                      </span>
                    </div>
                    <div className="icon-content">
                      <p>
                        <Link to={`mailto:${email}`}>{email}</Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-top bt0">
            <div className="container">
              <div className="row justify-content-between">
                <div className="col-xl-6 col-md-12">
                  <div className="widget widget-link-2">
                    <h5 className="footer-title">Våra Lösningar</h5>
                    <ul>
                      <li>
                        <Link to="/">Hem</Link>
                      </li>
                      <li>
                        <Link to="/kontakta-oss">Kontakta Oss</Link>
                      </li>
                      <li>
                        <Link to="/om-oss">Om Oss</Link>
                      </li>
                      <li>
                        <Link to="/tjanster/billackering-bilar-kungalv">
                          Lackering
                        </Link>
                      </li>
                      <li>
                        <Link to="/tjanster/skadeverkstad-i-goteborg-kungalv">
                          Skadebesiktning
                        </Link>
                      </li>
                      <li>
                        <Link to="/tjanster/bilverkstad-goteborg-kungalv-kbscenter">
                          Service
                        </Link>
                      </li>
                      <li>
                        <Link to="/tjanster/rekond-tvatt-kungalv">Rekond</Link>
                      </li>
                      <li>
                        <Link to="#">Bromsreparation</Link>
                      </li>
                      <li>
                        <Link to="#">Däck och Hjul</Link>
                      </li>
                      <li>
                        <Link to="#">Luftkonditionering</Link>
                      </li>
                      <li>
                        <Link to="#">Stenskott Laga</Link>
                      </li>
                      <li>
                        <Link to="#">Bilglas</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-xl-6 col-md-12">
                  <div className="widget footer_widget">
                    <h5 className="footer-title">KBS Center</h5>
                    <p className="mb-20">
                      Behöver du en specialreparation? Vi är glada att uppfylla
                      varje önskemål för att överträffa dina förväntningar.
                    </p>
                    <Link href={`tel:${telefon}`}>
                      <div className="ft-content">
                        <i className="fa fa-phone"></i>
                        <span style={{ color: "#878e9c" }}>
                          Prata med vår support
                        </span>
                        <h4>{telefon}</h4>
                      </div>
                    </Link>
                  </div>
                  <div className="col-xl-6 col-md-12">
                    <div className="widget widget_info">
                      <ul className="list-inline ft-social-bx">
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={instagramUrl}
                            className="btn button-sm"
                          >
                            <i className="fa-brands fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={tiktokUrl}
                            className="btn button-sm"
                          >
                            <i className="fa-brands fa-tiktok"></i>
                          </a>
                        </li>
                        <li>
                          <a
                            target="_blank"
                            rel="noreferrer"
                            href={facebookUrl}
                            className="btn button-sm"
                          >
                            <i className="fa-brands fa-facebook"></i>
                          </a>
                        </li>
                        {/* <li>
                          <a target="_blank" rel="noreferrer" href="https://youtube.com/" className="btn button-sm">
                            <i className="fa-brands fa-youtube"></i>
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 text-center text-md-start">
                  <p className="mb-0">
                    © Copyright Kungälv Bilskadecenter 2024. All right reserved.
                  </p>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 text-center text-md-end">
                  <ul className="widget-link">
                    <li>
                      <Link to="/">Hem</Link>
                    </li>
                    <li>
                      <Link to="#">Tjänster</Link>
                    </li>
                    <li>
                      <Link to="/kontakta-oss">Kontakta Oss</Link>
                    </li>
                    <li>
                      <Link to="/om-oss">Om Oss</Link>
                    </li>
                    <li>
                      <Link to="/vanliga-fragor-bilservice">FAQs</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}

export default aboutSection;
